import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import showAlert from '../alert/alertHandler';
import showConfirmation from '@waypoint/vue-confirmation';

import reportEscl from '../locales/es-CL/report.json';
import reportEsmx from '../locales/es-MX/report.json';
import reportEsco from '../locales/es-CO/report.json';
import reportEnus from '../locales/en-US/report.json';

import LogService from '../services/LogService';
import Container from 'typedi';
import moment from 'moment';

const date = new Date();

export default {
  name: 'Report',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        report: reportEscl,
      },
      'es-MX': {
        report: reportEsmx,
      },
      'es-CO': {
        report: reportEsco,
      },
      'en-US': {
        report: reportEnus,
      },
    },
  },
  data() {
    return {
      today: null,
      todayFormated: null,
      //Estados para clasesde css segun el estado del reporte
      isActiveProcess: true,
      isReadyProcess: false,
      isActiveGenerate: false,
      isReadyGenerate: false,
      isActiveStoring: false,
      isReadyStoring: false,
      isActiveAvailable: false,
      isReadyAvailable: false,
      reportSelected: null,
      actualStatusReport: null,
      linkDownload: null,
      isExcelReady: false,
      isFilterApplied: false,
      shortCutPath: null,
      firstTime: 0,
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 2,
      actualTimeExcecution: 0,
      limitTimeExecution: 900,
      rawVehicles: [],
      vehicles: [],
      driverSelected: [],
      vehicleSelected: [],
      statusActivity: [],
      optionsSpots: [],
      queryOptionsDocument: [],
      queryOptionsName: [],
      queryOptionsidRoute: [],
      statusOption: [],
      reportEnd: true,
      isBusy: false,
      activeFilters: false,
      filterActivity: false,
      filterRoute: false,
      filterBehavior: false,
      filterEvents: false,
      filterDeliveryActivitiesForm: false,
      filterDeliveryOperationForm: false,
      filterRouteOperation: false,
      filterOperationBehavior: false,
      filterOperation: false,
      filterEta: false,
      filters: {
        numberDocument: '',
        destinationSelected: '',
        originSelected: '',
        statusSelected: '',
        vehicleSelected: '',
        driverSelected: '',
        statusActivitySelected: '',
        typeEventSelected: '',
        routeId: '',
        name: '',
        clientList: [],
        period: null,
        from: null,
        until: null,
        plateList: [],
        routeAssignmentList: [],
        routeDriverList: [],
        optionTypes: '',
        world: '',
      },
      filterByPeriod: [
        {
          id: 1,
          key: "current",
          name: ""
        },
        {
          id: 2,
          key: "yesterday",
          name: ""
        },
        {
          id: 3,
          key: "lastWeek",
          name: ""
        },
        {
          id: 4,
          key: "currentMonth",
          name: ""
        },
        {
          id: 5,
          key: "lastMonth",
          name: ""
        }
      ],
      realNameType: [
        {
          id: 101,
          typeEvent: this.$t(`report.filters.typeEvent.door`),
        },
        {
          id: 102,
          typeEvent: this.$t(`report.filters.typeEvent.stop`),
        },
        {
          id: 103,
          typeEvent: this.$t(`report.filters.typeEvent.speed`),
        },
        {
          id: 104,
          typeEvent: this.$t(`report.filters.typeEvent.speedMax`),
        },
        {
          id: 105,
          typeEvent: this.$t(`report.filters.typeEvent.shutDown`),
        },
        {
          id: 106,
          typeEvent: this.$t(`report.filters.typeEvent.gps`),
        },
        {
          id: 107,
          typeEvent: this.$t(`report.filters.typeEvent.outOfRoute`),
        },
      ],
      optionsTypes: [
        {
          id: 2,
          name: this.$t('report.table.button.route'),
          key: 'routeReport',
          isCollapseClicked: false,
        },
        {
          id: 1,
          name: this.$t('report.table.button.activity'),
          key: 'activityReport',
          isCollapseClicked: false,
        },
        {
          id: 5,
          name: this.$t('report.table.button.deliveryActivities'),
          key: 'deliveryActivitiesFormReport',
          isCollapseClicked: false,
        },
        {
          id: 3,
          name: this.$t('report.table.button.behavior'),
          key: 'behaviorReport',
          isCollapseClicked: false,
        },
        {
          id: 4,
          name: this.$t('report.table.button.events'),
          key: 'eventReport',
          isCollapseClicked: false,
        },
        {
          id: 9,
          name: this.$t('report.table.button.operationReport'),
          key: 'operationReport',
          isCollapseClicked: false,
        },
        {
          id: 7,
          name: this.$t('report.table.button.routeOperations'),
          key: 'routeOperationReport',
          isCollapseClicked: false,
        },
        {
          id: 6,
          name: this.$t('report.table.button.deliveryOperations'),
          key: 'deliveryOperationFormReport',
          isCollapseClicked: false,
        },
        {
          id: 10,
          name: this.$t('report.table.button.eta'),
          key: 'etaFormReport',
          isCollapseClicked: false,
        }
      ],
      statesExcel: {
        RETRIEVING_DATA: 0,
        PROCESSING_DATA: 1,
        STORING: 2,
        AVAILABLE: 3,
      },
      bothWorlds: false,
      reportWorldOptions: [
        {
          id: 1,
          name: this.$t('report.table.button.oldReports'),
        },
        {
          id: 2,
          name: this.$t('report.table.button.newReports'),
        },
      ],
      selectedOld: false,
      selectedNew: false,
      timeoutID: null,
      logService: null,
    };
  },
  async created() {
    this.logService = Container.get(LogService);
    await this.prepareData();
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  methods: {
    onChangeType() {
      if (this.filters.optionTypes === null) {
        this.hideAllFilters();
        return;
      }
      this.cleanFilters();
      if (this.filters.optionTypes.id === 1) {
        this.prepareFilterActivity();
      } else if (this.filters.optionTypes.id === 2) {
        this.prepareFilterRoute();
      } else if (this.filters.optionTypes.id === 3) {
        this.prepareFilterBehavior();
      } else if (this.filters.optionTypes.id === 4) {
        this.prepareFilterEvents();
      } else if (this.filters.optionTypes.id === 5) {
        this.prepareFilterDeliveryActivities();
      } else if (this.filters.optionTypes.id === 6) {
        this.prepareFilterDeliveryOperation();
      } else if (this.filters.optionTypes.id === 7) {
        this.prepareFilterRouteOperation();
      } else if (this.filters.optionTypes.id === 8) {
        this.prepareFilterOperationBehavior();
      } else if (this.filters.optionTypes.id === 9) {
        this.prepareFilterOperation();
      } else if (this.filters.optionTypes.id == 10) {
        this.prepareFilterEta();
      }
    },
    onChangeWorld() {
      if (this.filters.world === null) {
        this.hideAllFilters();
        return;
      }
      this.cleanWorldFilters();
      this.cleanFilters();
      this.hideAllFilters();
      if (this.filters.world.id === 1) {
        this.selectedOld = true;
      } else if (this.filters.world.id === 2) {
        this.selectedNew = true;
      }
    },
    /**
     * Limpia los filtros para que al cambiar de reporte no se envien filtros no correspondientes a dicho reporte
     */
    cleanFilters() {
      this.filters.destinationSelected = '';
      this.filters.originSelected = '';
      this.filters.numberDocument = '';
      this.filters.statusSelected = '';
      this.filters.statusActivitySelected = '';
      this.filters.typeEventSelected = '';
    },
    cleanWorldFilters() {
      this.selectedNew = false;
      this.selectedOld = false;
      this.filters.optionTypes = '';
    },
    hideAllFilters() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterRoute() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = true;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterActivity() {
      this.activeFilters = true;
      this.filterActivity = true;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterBehavior() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = true;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterEvents() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = true;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterDeliveryActivities() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = true;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterDeliveryOperation() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterRouteOperation = false;
      this.filterDeliveryOperationForm = true;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterRouteOperation() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = true;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterOperationBehavior() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = true;
      this.filterEta = false;
      this.filterOperation = false;
    },
    prepareFilterOperation() {
      this.activeFilters = true;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterEta = false;
      this.filterOperation = true;
    },
    prepareFilterEta() {
      this.activeFilters = false;
      this.filterActivity = false;
      this.filterRoute = false;
      this.filterBehavior = false;
      this.filterEvents = false;
      this.filterDeliveryActivitiesForm = false;
      this.filterDeliveryOperationForm = false;
      this.filterRouteOperation = false;
      this.filterOperationBehavior = false;
      this.filterOperation = false;
      this.filterEta = true;
      var now = new Date()
      this.today = now.getTime();

      this.todayFormated = this.formatDate(now);
    },
    formatDate(date) {
      const day = ("0" + date.getDate()).slice(-2); // Asegura que el día tenga dos dígitos
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Los meses son indexados desde 0
      const year = date.getFullYear();
      const hours = ("0" + date.getHours()).slice(-2); // Asegura que las horas tengan dos dígitos
      const minutes = ("0" + date.getMinutes()).slice(-2); // Asegura que los minutos tengan dos dígitos
  
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      if (this.dataAccess.canNavReportBasic && this.dataAccess.canNavReport) {
        this.bothWorlds = true;
      } else if (this.dataAccess.canNavReportBasic && !this.dataAccess.canNavReport) {
        this.selectedNew = true;
      } else {
        this.selectedOld = true;
      }
      this.isBusy = true;
      await this.getSpots();
      await this.getStatusActivity();
      await this.getClients();
      await this.getDrivers();
      await this.getStatus();
      await this.getVehicles();
      this.isBusy = false;
    },
    async getSpots() {
      const urlSpots = `${this.$store.getters.urlAPI}/api/spot/temporal?withAllTemporal=false`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await this.axios.get(urlSpots, config);
        this.optionsSpots = response.data.data;
      } catch (e) {
        console.log(e);
        this.optionsSpots = [];
      }
    },
    async getStatusActivity() {
      const urlStatus = `${this.$store.getters.urlAPI}/status`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const statusPromise = await this.axios.get(urlStatus, config);
        this.statusActivity = statusPromise.data.data;
      } catch (e) {
        console.log(e);
        this.statusActivity = [];
      }
    },
    async getClients() {
      const urlClients = `${this.$store.getters.urlAPI}/api/client/all`;
      this.filters.clientList = [];
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlClients, config);
        response.data.data.forEach((element) => {
          this.filters.clientList.push(element);
        });
        this.filters.clientList.sort(function (a, b) {
          if (a.name[0] > b.name[0]) {
            return 1;
          }
          if (a.name[0] < b.name[0]) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getDrivers() {
      const urlDrivers = `${this.$store.getters.urlAPI}/api/driver?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const driverPromise = await axios.get(urlDrivers, config);

        this.filters.routeDriverList = driverPromise.data.data;
        this.filters.routeDriverList.forEach((driver) => {
          driver.userFirstnameLastnameClientName =
            this.transformWords(driver.firstName) +
            ' ' +
            this.transformWords(driver.lastName) +
            ' - ' +
            this.filters.clientList.find((client) => driver.idClient === client.id).name;
        });
        this.filters.routeDriverList.sort((a, b) => a.firstName.localeCompare(b.firstName));
      } catch (e) {
        console.log(e);
      }
    },
    async getStatus() {
      const urlStatus = `${this.$store.getters.urlAPI}/statusRoute`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const statusPromise = await this.axios.get(urlStatus, config);
        this.statusOption = statusPromise.data.data;
      } catch (e) {
        console.log(e);
        this.statusOption = [];
      }
    },
    async getVehicles() {
      const urlVehicles = `${this.$store.getters.urlAPI}/api/vehicle?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehiclePromise = await axios.get(urlVehicles, config);
        this.rawVehicles = vehiclePromise.data.data;
        this.rawVehicles.forEach((vehicle) => {
          vehicle.nameClient = this.filters.clientList.find((element) => element.id === vehicle.idClient).name;
        });
        this.vehicles = this.rawVehicles;
      } catch (e) {
        console.log(e);
      }
    },
    validateRestinationRequired() {
      if (this.filters.destinationSelected == "") {
        showAlert('Error', 'Debe ingresar el Destino');
        return false;
      } 
      return true;
    },
    validateDateRange(date1, date2) {
      if (date1 === null || date2 === null) {
        showAlert('Error', 'Debe ingresar el rango de fechas Desde y Hasta');
        return false;
      }
      const startDate = new moment(date1);
      const endDate = new moment(date2);
      const diffDays = endDate.diff(startDate, 'days');
      console.log('Diff in days:', diffDays);
      if (diffDays >= 31) {
        showAlert('Error', 'El rango de fechas no puede exceder los 31 días.');
        return false;
      }
      return true;
    },
    notExistElement(array, element) {
      for (const e of array) {
        if (e === element) {
          return false;
        }
      }
      return true;
    },
    async cleanStatesReport() {
      this.actualStatusReport = null;
      this.isExcelReady = false;
      this.actualTimeExcecution = 0;
      this.firstTime = 0;
      this.autoRefreshTimer = 0;
      this.isActiveProcess = true;
      this.isReadyProcess = false;
      this.isActiveGenerate = false;
      this.isReadyGenerate = false;
      this.isActiveStoring = false;
      this.isReadyStoring = false;
      this.isActiveAvailable = false;
      this.isReadyAvailable = false;
    },
    async getReport(typeReport) {
      this.isBusyBehavior = true;
      await this.cleanStatesReport();
      if(typeReport == "etaFormReport"){
        if (this.validateRestinationRequired()) {
          this.reportSelected = typeReport;
          this.openModal();
          await this.getReportEtaFormData();
        }
      } else if (this.validateDateRange(this.filters.from, this.filters.until)) {
        this.reportSelected = typeReport;
        this.openModal();
        if(typeReport == "routeReport"){
          await this.getReportRouteData();
        }
        if(typeReport == "activityReport"){
          await this.getReportActivityData();
        }
        if(typeReport == "deliveryActivitiesFormReport"){
          await this.getReportDeliveryActivitiesFormData();
        }
        if(typeReport == "behaviorReport"){
          await this.getReportBehaviorData();
        }
        if(typeReport == "eventReport"){
          await this.getEventReportData();
        }
        if(typeReport == "operationReport"){
          await this.getReportOperationData();
        }
        if(typeReport == "routeOperationReport"){
          await this.getReportRouteOperationData();
        }
        if(typeReport == "deliveryOperationFormReport"){
          await this.getReportDeliveryOperationFormData();
        }
      }
      this.isBusyActivity = false;
    },
    async getEventReportData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('EVENTS');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getEventReportData fallo ${e.message}`
        });
        console.log(e);
      }
    },
    async getReportBehaviorData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('VEHICLE_BEHAVIOR');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportBehaviorData fallo ${e.message}`
        });
        console.log(e);
      }
    },
    async getReportOperationBehaviorData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('OPERATION_VEHICLE_BEHAVIOR');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportOperationBehaviorData fallo ${e.message}`
        });
        console.log(e);
        return [];
      }
    },
    async getReportRouteData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('ROUTE_FULFILLMENT');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportRouteData fallo ${e.message}`
        });
        console.log(e);
      }
    },
    async getReportActivityData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('ACTIVITY_FULFILLMENT');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportActivityData fallo ${e.message}`
        });
        console.log(e);
      }
    },
    async getReportRouteOperationData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('OPERATION_FORMS_ROUTE');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportRouteOperationData fallo ${e.message}`
        });
        console.log(e);
        return [];
      }
    },
    async getReportOperationData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('OPERATION_FULFILLMENT');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportOperationData fallo ${e.message}`
        });
        console.log(e);
      }
    },
    async getReportEtaFormData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('ETA');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        console.log(e);
        this.logService.sendError({
          component: "report",
          message: `getReportEtaFormData fallo ${e.message}`
        });
      }
    },
    async getReportDeliveryOperationFormData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('OPERATION_FORMS');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportDeliveryOperationFormData fallo ${e.message}`
        });
        console.log(e);
      }
    },
    async getReportDeliveryActivitiesFormData() {
      const url = `${this.$store.getters.urlAPI}/report/request`;
      this.isFilterApplied = false;
      const bodyFilter = this.prepareFilters('ACTIVITY_FORMS');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const activityReportPromise = await this.axios.post(url, bodyFilter, config);
        this.executionId = activityReportPromise.data.executionId;
        this.reportEnd = false;
        this.autoRefresh();
        console.log('request :', activityReportPromise);
      } catch (e) {
        this.logService.sendError({
          component: "report",
          message: `getReportDeliveryActivitiesFormData fallo ${e.message}`
        });
        console.log(e);
        return [];
      }
    },
    prepareFilters(reportType) {
      const bodyFilter = {
        reportType: reportType,
        reportFormat: ['XLS'],
      };
      if (reportType == 'ETA') {
        bodyFilter['currentDateFilter'] = this.today;
        bodyFilter['reportZone'] = this.$store.getters.timeZone;
        this.isFilterApplied = true;
      }

      //Filtro fecha desde
      if (this.filters.from) {
        const dateFrom = new Date(this.filters.from);
        const secondsFrom = dateFrom.getTime();
        bodyFilter['startDateFilter'] = secondsFrom;
        this.isFilterApplied = true;
      }
      //Filtro fecha hasta
      if (this.filters.until) {
        const dateUntil = new Date(this.filters.until);
        const secondsUntil = dateUntil.getTime();
        bodyFilter['endDateFilter'] = secondsUntil;
        this.isFilterApplied = true;
      }
      //Filtro oculto que envia la zona horaria al back
      if (this.filters.until) {
        bodyFilter['reportZone'] = this.$store.getters.timeZone;
      }
      //Filtro nombre de ruta
      if (this.filters.name) {
        bodyFilter['nameFilter'] = this.filters.name;
        this.isFilterApplied = true;
        if (this.notExistElement(this.queryOptionsName, this.filters.name)) {
          this.queryOptionsName.push(this.filters.name);
        }
      }
      //Filtro id de ruta
      if (this.filters.routeId) {
        bodyFilter['idFilter'] = this.filters.routeId;
        this.isFilterApplied = true;
        if (this.notExistElement(this.queryOptionsidRoute, this.filters.routeId)) {
          this.queryOptionsidRoute.push(this.filters.routeId);
        }
      }
      //Filtro de tipo de evento selecciconado
      if (this.filters.typeEventSelected) {
        bodyFilter['typeEvent'] = this.filters.typeEventSelected.id;
        bodyFilter['nameTypeEvent'] = this.filters.typeEventSelected.typeEvent;
        this.isFilterApplied = true;
      }
      //Filtro de estado de ruta seleccionado
      if (this.filters.statusSelected) {
        const listStatusId = [];
        let listStatusName = null;
        let index = 0;
        for (const status of this.filters.statusSelected) {
          listStatusId.push(status.id);
          if (index === 0) {
            listStatusName = status.name;
          } else {
            listStatusName = `${listStatusName}, ${status.name}`;
          }
          index += 1;
        }
        bodyFilter['idsStatusFilter'] = listStatusId;
        bodyFilter['nameStatusFilter'] = listStatusName;
        this.isFilterApplied = true;
      }
      //Filtro de estado de actividad seleccionado
      if (this.filters.statusActivitySelected) {
        let listStatusId = [];
        let listStatusName = null;
        let index = 0;
        for (let status of this.filters.statusActivitySelected) {
          listStatusId.push(status.id);
          if (index === 0) {
            listStatusName = status.name;
          } else {
            listStatusName = `${listStatusName}, ${status.name}`;
          }
          index += 1;
        }
        bodyFilter['idsStatusFilter'] = listStatusId;
        bodyFilter['nameStatusFilter'] = listStatusName;
        this.isFilterApplied = true;
      }
      //Filtro de conductores seleccionados
      if (this.filters.driverSelected) {
        const listDriversId = [];
        let listDriverUsername = null;
        let index = 0;
        for (const driver of this.filters.driverSelected) {
          listDriversId.push(driver.id);
          if (index === 0) {
            listDriverUsername = driver.username;
          } else {
            listDriverUsername = `${listDriverUsername}, ${driver.username}`;
          }
          index += 1;
        }
        bodyFilter['idsOperadorFilter'] = listDriversId;
        bodyFilter['nameOperadorFilter'] = listDriverUsername;
        this.isFilterApplied = true;
      }
      //Filtro de vehículos seleccionados
      if (this.filters.vehicleSelected) {
        const listVehiclesId = [];
        let listVehiclesName = null;
        let index = 0;
        for (const vehicle of this.filters.vehicleSelected) {
          listVehiclesId.push(vehicle.id);
          if (index === 0) {
            listVehiclesName = vehicle.plate;
          } else {
            listVehiclesName = `${listVehiclesName}, ${vehicle.plate}`;
          }
          index += 1;
        }
        bodyFilter['idVehiclesFilter'] = listVehiclesId;
        bodyFilter['nameVehiclesFilter'] = listVehiclesName;
        this.isFilterApplied = true;
      }
      //Filtro de número de documento indicado
      if (this.filters.numberDocument) {
        bodyFilter['numberDocument'] = this.filters.numberDocument;
        this.isFilterApplied = true;
        if (this.notExistElement(this.queryOptionsDocument, this.filters.numberDocument)) {
          this.queryOptionsDocument.push(this.filters.numberDocument);
        }
      }
      //Filtro de origenes seleccionados
      if (this.filters.originSelected) {
        const listOriginsId = [];
        let listOriginsName = null;
        let index = 0;
        for (const origin of this.filters.originSelected) {
          listOriginsId.push(origin.id);
          if (index === 0) {
            listOriginsName = origin.name;
          } else {
            listOriginsName = `${listOriginsName}, ${origin.name}`;
          }
          index += 1;
        }
        bodyFilter['idsOriginFilter'] = listOriginsId;
        bodyFilter['nameOriginFilter'] = listOriginsName;
        this.isFilterApplied = true;
      }
      //Filtro de destinos seleccionados
      if (this.filters.destinationSelected) {
        let listDestinationId = [];
        let listDestinationName = null;
        let index = 0;
        if(Array.isArray(this.filters.destinationSelected)) {
          for (const destination of this.filters.destinationSelected) {
            listDestinationId.push(destination.id);
            if (index === 0) {
              listDestinationName = destination.name;
            } else {
              listDestinationName = `${listDestinationName}, ${destination.name}`;
            }
            index += 1;
          }
        } else {
          listDestinationId.push(this.filters.destinationSelected.id);
          listDestinationName = this.filters.destinationSelected.name;
        }
        bodyFilter['idsDestinationFilter'] = listDestinationId;
        bodyFilter['nameDestinationFilter'] = listDestinationName;
        this.isFilterApplied = true;
      }
      this.logService.sendInfo({
        component: "report",
        message: `${reportType} consultando ${bodyFilter}`
      });
      return bodyFilter;
    },
    autoRefresh() {
      if (this.$route.name !== 'Report') {
        return;
      }
      if (!this.reportEnd && this.actualTimeExcecution != this.limitTimeExecution) {
        if (this.firstTime == 2) {
          if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
            this.timeoutID = setTimeout(() => {
              this.autoRefreshTimer += 1;
              this.autoRefresh();
            }, 1000);
          } else {
            this.autoRefreshTimer = 0;
            this.actualTimeExcecution += 1;
            this.getStatusExcel();
            this.autoRefresh();
          }
        } else {
          this.timeoutID = setTimeout(() => {
            this.firstTime += 1;
            this.autoRefresh();
          }, 1000);
        }
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
    async getStatusExcel() {
      try {
        const url = `${this.$store.getters.urlAPI}/report/checkStatus/${this.executionId}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let statusExcel = await this.axios.get(url, config);
        console.log('test fase', statusExcel.data.phase);
        if (statusExcel.data.phase != 'NOT_FOUND') {
          this.actualStatusReport = statusExcel.data.phase;
          if (this.actualStatusReport == 'AVAILABLE') {
            this.reportEnd = true;
            this.isExcelReady = true;
            this.linkDownload = statusExcel.data.location;
          }
          console.log('report activity:', statusExcel);
        }
      } catch (e) {
        console.log(e);
        this.reportEnd = true;
        showAlert('Error', 'Fallo la solicitud del reporte');
        return [];
      }
    },
    openModal() {
      this.showModal('report-modal');
    },
    confirmation() {
      if (!this.reportEnd) {
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          this.$t('report.modal.confirmClose'),
          () => {
            this.reportEnd = true;
            this.closeModal();
          },
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      } else {
        this.closeModal();
      }
    },
    closeModal() {
      this.$bvModal.hide('report-modal');
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    limitText(count) {
      return this.$t('report.search.limitText') + (count + 1);
    },
    getNameReport(reportType) {
      return this.$t(`report.modal.typeReport["${String(reportType)}"]`);
    },
    /**
     * Metodo que retorna a la vista anterior.
     * @param {String} shortCutPath, nombre de la ruta.
     * @returns vista anterior.
     */
    returnToPage(shortCutPath) {
      return this.$router.push({ name: shortCutPath });
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    toogleCollapse(report, idCollapse) {
      if (
        this.filters.optionTypes &&
        this.filters.optionTypes.idCollapse != idCollapse &&
        this.filters.optionTypes.isCollapseClicked
      ) {
        console.log();
        this.filters.optionTypes.isCollapseClicked = !this.filters.optionTypes.isCollapseClicked;
        this.$root.$emit('bv::toggle::collapse', this.filters.optionTypes.idCollapse);
      }
      this.filters.optionTypes = report;
      this.filters.optionTypes.idCollapse = idCollapse;
      this.filters.optionTypes.isCollapseClicked = !this.filters.optionTypes.isCollapseClicked;
      this.onChangeType();
      this.$root.$emit('bv::toggle::collapse', idCollapse);
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    checkComponentPresence(ref) {
      if (this.$refs[ref] && this.$refs[ref].length > 0) {
        return this.$refs[ref][0].show;
      }
    },
    validateAccess(report) {
      let access = false;
      console.log(report)
      if (this.bothWorlds) {
        access = true;
      } else if (
        (this.selectedOld && (report.id == 1 || report.id == 2 || report.id == 3 || report.id == 4 || report.id == 5 || report.id == 10)) ||
        (this.selectedNew && (report.id == 6 || report.id == 7 || report.id == 8 || report.id == 9))
      ) {
        access = true;
      }
      return access;
    },
    changePeriod(){
      if(this.filters.period != null){
        if(this.filters.period.key == 'current'){
          const currentDay = this.currentDay;
          this.filters.from = currentDay.from;
          this.filters.until = currentDay.until;
        }else if(this.filters.period.key == 'yesterday'){
          const yesterday = this.yesterday;
          this.filters.from = yesterday.from;
          this.filters.until = yesterday.until;
        }else if(this.filters.period.key == 'lastWeek'){
          const lastWeek = this.lastWeek;
          this.filters.from = lastWeek.from;
          this.filters.until = lastWeek.until;
        }else if(this.filters.period.key == 'currentMonth'){
          const currentMonth = this.currentMonth;
          this.filters.from = currentMonth.from;
          this.filters.until = currentMonth.until;
        }else if(this.filters.period.key == 'lastMonth'){
          const lastMonth = this.lastMonth;
          this.filters.from = lastMonth.from;
          this.filters.until = lastMonth.until;
        }
      }
    },
    //Checkea que si modifico la fecha manualmente, el filtro de periodo se vacia
    checkChangeFrom(event){
      if(this.filters.period !== null){
        if(
          (this.filters.period.key == 'current' && this.currentDay.from != event) ||
          (this.filters.period.key == 'yesterday' && this.yesterday.from != event) ||
          (this.filters.period.key == 'lastWeek' && this.lastWeek.from != event) ||
          (this.filters.period.key == 'currentMonth' && this.currentMonth.from != event) ||
          (this.filters.period.key == 'lastMonth' && this.lastMonth.from != event)

         ){
          this.filters.period = null;
        }
      }
    },
    //Checkea que si modifico la fecha manualmente, el filtro de periodo se vacia
    checkChangeUntil(event){
      if(this.filters.period !== null){
        if(
          (this.filters.period.key == 'current' && this.currentDay.until != event) ||
          (this.filters.period.key == 'yesterday' && this.yesterday.until != event) ||
          (this.filters.period.key == 'lastWeek' && this.lastWeek.until != event) ||
          (this.filters.period.key == 'currentMonth' && this.currentMonth.until != event) ||
          (this.filters.period.key == 'lastMonth' && this.lastMonth.until != event)

         ){
          this.filters.period = null;
        }
      }
    }
  },
  computed: {
    currentDay() {
      let untilNow = date;
      let initDay = new Date(date);
      return {
        until: new moment(untilNow).format('YYYY-MM-DD HH:mm:ss'),
        from: new moment(initDay.setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss'),
      }
    },
    yesterday(){
      let yesterday = new Date(date);
      yesterday.setDate(date.getDate()-1);
      return {
        from: new moment(yesterday.setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss'),
        until: new moment(yesterday.setHours(23, 59, 59, 0)).format('YYYY-MM-DD HH:mm:ss'),
      }
    },
    lastWeek(){
      let lastWeekM = new Date(date);
      //Obtengo el ultimo lunes
      lastWeekM.setDate(date.getDate()- (date.getDay() + 6));
      let lastWeekS = new Date(date);
      //Obtengo el ultimo domingo
      lastWeekS.setDate(date.getDate() - date.getDay());
      return {
        from: new moment(lastWeekM.setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss'),
        until: new moment(lastWeekS.setHours(23, 59, 59, 0)).format('YYYY-MM-DD HH:mm:ss'),
      }
    },
    currentMonth(){
      const untilDay = date;
      let firstDayMonth = new Date(date);
      firstDayMonth.setDate(1);
      return {
        from: new moment(firstDayMonth.setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss'),
        until: new moment(untilDay).format('YYYY-MM-DD HH:mm:ss'),
      }
    },
    lastMonth(){
      let firstDayMonth = new Date(date);
      firstDayMonth.setMonth(firstDayMonth.getMonth() - 1);
      firstDayMonth.setDate(1);
      let lastDayMonth = new Date(date);
      //Obtener el ultimo dia del mes
      lastDayMonth.setDate(firstDayMonth.getDate() - 1);
      return {
        from: new moment(firstDayMonth.setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss'),
        until: new moment(lastDayMonth.setHours(23, 59, 59, 0)).format('YYYY-MM-DD HH:mm:ss'),
      }
    },
    fromManagement() {
      return !!this.$route.query.fromManagement;
    },
    processState() {
      if (this.actualStatusReport == null || this.statesExcel[this.actualStatusReport] < 1) {
        this.isActiveProcess = true;
        this.isReadyProcess = false;
      } else {
        this.isActiveProcess = false;
        this.isReadyProcess = true;
      }
    },
    generateState() {
      if (this.actualStatusReport == null || this.statesExcel[this.actualStatusReport] < 1) {
        this.isActiveGenerate = false;
        this.isReadyGenerate = false;
      } else {
        if (this.statesExcel[this.actualStatusReport] == 1) {
          this.isActiveGenerate = true;
          this.isReadyGenerate = false;
        } else {
          this.isActiveGenerate = false;
          this.isReadyGenerate = true;
        }
      }
    },
    storingState() {
      if (this.actualStatusReport == null || this.statesExcel[this.actualStatusReport] < 2) {
        this.isActiveStoring = false;
        this.isReadyStoring = false;
      } else {
        if (this.statesExcel[this.actualStatusReport] == 2) {
          this.isActiveStoring = true;
          this.isReadyStoring = false;
        } else {
          this.isActiveStoring = false;
          this.isReadyStoring = true;
        }
      }
    },
    availableState() {
      if (this.actualStatusReport == null || this.statesExcel[this.actualStatusReport] < 3) {
        this.isActiveAvailable = false;
        this.isReadyAvailable = false;
      }
      if (this.statesExcel[this.actualStatusReport] == 3) {
        this.isActiveAvailable = false;
        this.isReadyAvailable = true;
      }
    },
    optionPeriod(){
      return this.filterByPeriod.map((filter)=>{
        return {
          ...filter,
          name: this.$t(`report.filters.options.${filter.key}`)
        }
      })
    },
  },
};
